import React, {Component} from 'react';
import moment from "moment";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";

class TimerBookingForm extends Component {

	constructor(props) {
		super(props);
		this.state = {minutes:0, seconds: 0};
		window.startBooking = this.startBooking.bind(this);
		window.stopBooking = this.stopBooking.bind(this);
		this.formatterDate = this.formatterDate.bind(this);
	}

	componentDidMount() {
//		console.log('componentDidMount');
		this.startBooking();
	}

	startBooking() {
		clearTimeout(window.timerID);
		let endBooking = window.localStorage.getItem('end_create_booking');
		let startStatus = window.localStorage.getItem('start_create_booking');
		if (endBooking && startStatus === '1') {
			let endTime = moment(endBooking, "DD-MM-YYYY hh:mm:ss A").valueOf();
			let startTime = moment().valueOf();
			let duration = endTime - startTime;
			if (duration < 0) {
				showPopupWithGoBack('<div class="text-center">The time to create a booking has expired.<br/>You can try again.</div>');
				this.stopBooking();
				setTimeout(() => {this.props.resetBookingData(this.props.hire);}, 2000);
				return false;
			}
			let seconds = parseInt((duration/1000)%60);
			let minutes = parseInt((duration/(1000*60))%60);
			this.setState({minutes, seconds});
			window.timerID = setTimeout(()=>this.startBooking(), 1000);
		} else
			this.stopBooking();
	}

	stopBooking() {
		clearTimeout(window.timerID);
		this.setState({ minutes:0, seconds: 0});
		window.localStorage.setItem('start_create_booking', '0');
	}

	componentWillUnmount() {
//		console.log('componentWillUnmount');
		this.stopBooking();
		window.startBooking = window.stopBooking = null;
	}

	formatterDate() {
		let minutes = this.state.minutes;
		let seconds = this.state.seconds;
		let timeDisplay = '';

		timeDisplay += ((minutes < 10) ? "0" + minutes : minutes) + ' Mins';

		timeDisplay += ' ' + ((seconds < 10) ? "0" + seconds : seconds) + ' Sec';

		return <span className={'timer'}>{timeDisplay}</span>
	}

	render() {
		return (
			<>
				{
					(this.state.minutes || this.state.seconds) ? (
						<div className={'timer_booking_end '+((this.state.minutes === 0 && this.state.seconds < 60) && 'timer_booking_end_red')}>
							<div>Time To Booking:</div>
							<div>{this.formatterDate()}</div>
						</div>
					) : ('')
				}
			</>
		);
	}
}

export default TimerBookingForm;